import HeroToast from './HeroToast';

export default HeroToast;
